// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"fd0833c968c7dbbe91d8","532":"f13240896d1c6d2d5e23","691":"a783ddd058b651f3c95d"}[chunkId] + ".js";
};